import React from 'react';
import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';
import TeamNames from 'components/teamNames';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './teamCreation.md';
import markdownFile_fr_CA from './teamCreation.fr_CA.md';

import apprenticesRowArmsFolded from '../../images/characters/apprenticesRowArmsFolded.png';
import apprenticeHandsHips from '../../images/characters/apprenticeHandsHips.png';
import apprenticeArmsFolded from '../../images/characters/apprenticeArmsFolded.png';
import apprenticePointingDiagonal from '../../images/characters/apprenticePointingDiagonal.png';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

export function preloadGameShow () {
  preloader([
    apprenticesRowArmsFolded,
    apprenticeHandsHips,
    apprenticeArmsFolded,
    apprenticePointingUp
  ]);
}

function teamCreationSection ({ regionData, i18n }) {
  const md_i18n = i18n(md);
  return (
    <Section id="team-creation">

      {/* Sara and Ian welcome to Academy */}
      {videoSlide({
        id: 'welcome',
        notes: md_i18n.getSubSectionAsHtml('Welcome Video', 'Notes', false, regionData),
        youTubeId: md_i18n.getSectionMetadata('Welcome Video', 'YouTube', regionData)
      })}

      {/* Get into teams and come up with a cool name */}
      {balloonSlide({
        id: 'get-into-teams',
        characterSide: 'right',
        characterImage: apprenticeArmsFolded,
        notes: md_i18n.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
        html: md_i18n.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
      })}

      {/* Enter team names */}
      <Slide
          id="assign"
          bgColor="black"
          notes="<h2>Assign Team Names</h2>"
          teamNames>
        <div className="ui-slide">
          <Heading size={1}>
            {i18n('Name your teams!')}
          </Heading>
          <TeamNames />
        </div>
      </Slide>

      {/* Scoring intro */}
      {balloonSlide({
        id: 'scoring-intro',
        characterSide: 'right',
        characterImage: apprenticeHandsHips,
        notes: md_i18n.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
        html: md_i18n.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
      })}

      {/* Introduce scoreboard */}
      {balloonSlide({
        id: 'scoreboard-intro',
        characterSide: 'right',
        characterImage: apprenticePointingDiagonal,
        notes: md_i18n.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
        html: md_i18n.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
      })}

      {/* ID cards draw your avatar */}
      {balloonSlide({
        id: 'id-cards',
        characterSide: 'left',
        characterImage: apprenticesRowArmsFolded,
        notes: md_i18n.getSubSectionAsHtml('ID Cards', 'Notes', false, regionData),
        html: md_i18n.getSubSectionAsHtml('ID Cards', 'Content', false, regionData)
      })}

    </Section>

  );
}

export default teamCreationSection;



// WEBPACK FOOTER //
// ./programs/keepCool/sections/10_teamCreation/teamCreationSection.jsx